
import { LoginComponent } from './login.component';
import { ForgotPassFormComponent } from './forgot-pass-form/forgot-pass-form.component';
import { RegisterFormComponent } from './register-form/register-form.component';
import { LoginFormComponent } from './login-form/login-form.component';

export const LOGIN_COMPONENTS: any[] = [
    LoginComponent,
    LoginFormComponent,
    RegisterFormComponent,
    ForgotPassFormComponent
];
